import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";

import MaterialInput from "@material-ui/core/Input";
import InputAdornment from "@material-ui/core/InputAdornment";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import InputLabel from "@material-ui/core/InputLabel";

//import Input from '@material-ui/core/Input';
import Grid from "@material-ui/core/Grid";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import ListItemText from "@material-ui/core/ListItemText";
import Select from "@material-ui/core/Select";

import Icon from "../Icon";

//import withWidth from '@material-ui/core/withWidth';
import { debounce } from "lodash";

import SimpleSelect from "./SimpleSelect";
import ComplexSelect from "./ComplexSelect";
import NativeSelect from "./NativeSelect";
import SearchSelect from "./SearchSelect";
import CheckboxSelect from "./CheckboxSelect";
import AdvancedCheckbox from "./AdvancedCheckBox";

const styles = theme => ({
  formControl: {
    width: "auto"
  },
  formControl_fullwidth: {
    width: "100%",

    [theme.breakpoints.up("sm")]: {
      width: "auto"
    }
  },
  formControl_with_border: {
    border: `1px solid ${theme.palette.lightGrey}`
  },
  labelClass: {
    ...theme.subtitle1,
    color: `${theme.palette.deepGrey} !important`
  }
});

class DropDownComponent extends React.PureComponent {
  state = {
    open: false,
    im_hovered_upon: false
  };

  componentDidMount() {
    this.hasListeneter = true;
  }

  componentWillUnmount() {
    this.hasListeneter = false;
  }

  handleClose = () => {
    if (this.state.open && this.hasListeneter) {
      this.setState({ open: false });
    }
  };

  handleOpen = (e, disabled) => {
    if (!this.state.open && !disabled && this.hasListeneter) {
      this.setState({ open: true, im_hovered_upon: false });
    }
  };

  hover = (e, enter, disabled) => {
    if (!disabled && this.hasListeneter) {
      this.setState({ im_hovered_upon: enter });
    }
  };

  getCompType = type => {
    switch (type) {
      case "simple":
        return SimpleSelect;
      case "checkbox":
        return CheckboxSelect;
      case "search-select":
        return SearchSelect;
      case "complex":
        return ComplexSelect;
      case "advanced-checkbox":
        return AdvancedCheckbox;
      case "basic":
      default:
        return NativeSelect;
    }
  };
  render() {
    const {
      type,
      className,
      full_width_xs,
      label,
      icon,
      classes,
      ...props
    } = this.props;

    const Component = this.getCompType(type);
    return (
      <FormControl
        className={`${
          full_width_xs ? classes.formControl_fullwidth : classes.formControl
        } ${className}`}
      >
        {Boolean(label) && (
          <InputLabel
            htmlFor={`label-${label}`}
            classes={{ formControl: classes.labelClass }}
          >
            {label}
          </InputLabel>
        )}
        <Component
          {...this.state}
          handleClose={this.handleClose}
          handleOpen={this.handleOpen}
          onMouseEnter={debounce(e => this.hover(e, true), 150)}
          onMouseLeave={debounce(this.hover, 150)}
          full_width_xs={full_width_xs}
          autoWidth
          {...props}
          type={icon && "icon"}
        />
      </FormControl>
    );
  }
}

DropDownComponent.propTypes = {
  type: PropTypes.oneOf(["basic", "checkbox", "advanced-checkbox", "complex"])
    .isRequired,
  icon: PropTypes.bool
};

DropDownComponent.defaultProps = {
  type: "basic"
};

export default React.memo(props => {
  const Component = React.useMemo(() => {
    switch (props.type) {
      case "advanced-checkbox":
        return AdvancedCheckbox;
      default:
        return withStyles(styles)(DropDownComponent);
    }
  }, [props.type]);
  return <Component {...props} />;
});
//      <FormControl className={`${full_width_xs ? formControl_fullwidth : formControl} ${className}`}>
